import React from 'react';
import Slider from "react-slick";
import { Link } from 'react-router-dom';

// --- 1. CONFIGURATION: Category IDs (You can update these from your DB) ---
const CATEGORY_IDS = {
  MEDICAL: 101,
  CONSTRUCTION: 102,
  FASHION: 103,
  INDUSTRIAL: 15,
  HOME: 8,
  ELECTRONICS: 12
};

// --- MOCK DATA for Blue Slider Section (Updated Names & Images) ---
interface GridCategory {
  id: number;
  name: string;
  imagePlaceholder: string; 
}

const mainGridCategories: GridCategory[] = [
  { 
    id: CATEGORY_IDS.MEDICAL, 
    name: 'Medical Supplies', 
    imagePlaceholder: 'https://images.unsplash.com/photo-1584017911766-d451b3d0e843?auto=format&fit=crop&q=80&w=400&h=300' 
  },
  { 
    id: CATEGORY_IDS.CONSTRUCTION, 
    name: 'Construction & Tiles', 
    imagePlaceholder: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&q=80&w=400&h=300' 
  },
  { 
    id: CATEGORY_IDS.FASHION, 
    name: 'Apparel & Fashion', 
    imagePlaceholder: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?auto=format&fit=crop&q=80&w=400&h=300' 
  },
  { 
    id: CATEGORY_IDS.INDUSTRIAL, 
    name: 'Industrial Machinery', 
    imagePlaceholder: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&q=80&w=400&h=300' 
  },
  { 
    id: CATEGORY_IDS.HOME, 
    name: 'Home Appliances', 
    imagePlaceholder: 'https://cdn.firstcry.com/education/2023/01/13101355/Names-Of-Household-Appliances-In-English.jpg' 
  },
  { 
    id: CATEGORY_IDS.ELECTRONICS, 
    name: 'Electrical Components', 
    imagePlaceholder: 'https://images.unsplash.com/photo-1555664424-778a1e5e1b48?auto=format&fit=crop&q=80&w=400&h=300' 
  },
  { 
    id: 107, 
    name: 'Office Supplies', 
    imagePlaceholder: 'https://images.unsplash.com/photo-1497215728101-856f4ea42174?auto=format&fit=crop&q=80&w=400&h=300' 
  },
  { 
    id: 108, 
    name: 'Safety Equipment', 
    imagePlaceholder: 'https://img.freepik.com/premium-photo/safety-equipment-personal-protective-equiptments_106035-3448.jpg' 
  },
];

// --- 2. STATIC DATA FOR BOTTOM 3 GRIDS (Updated to match TradyFrog Theme) ---
const bottomGridData = [
    { 
        title: "Medical & Health", 
        description: "Oximeters, Masks & Equipment.",
        categoryId: CATEGORY_IDS.MEDICAL, 
        borderColor: "border-teal-600",
        images: [
            "https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?auto=format&fit=crop&q=80&w=200&h=200", 
            "https://images.unsplash.com/photo-1583947215259-38e31be8751f?auto=format&fit=crop&q=80&w=200&h=200",
            "https://images.unsplash.com/photo-1631549916768-4119b2e5f926?auto=format&fit=crop&q=80&w=200&h=200"
        ]
    },
    { 
        title: "Construction Material", 
        description: "Tiles, Tools, Cutters & Cement.",
        categoryId: CATEGORY_IDS.CONSTRUCTION, 
        borderColor: "border-orange-500",
        images: [
            "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?auto=format&fit=crop&q=80&w=200&h=200",
            "https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?auto=format&fit=crop&q=80&w=200&h=200",
            "https://images.unsplash.com/photo-1581235720704-06d3acfcb36f?auto=format&fit=crop&q=80&w=200&h=200"
        ]
    },
    { 
        title: "Fashion & Lifestyle", 
        description: "Men's Wear, Bags & Accessories.",
        categoryId: CATEGORY_IDS.FASHION, 
        borderColor: "border-purple-600",
        images: [
            "https://images.unsplash.com/photo-1593030761757-71bd90dbe786?auto=format&fit=crop&q=80&w=200&h=200",
            "https://images.unsplash.com/photo-1584917865442-de89df76afd3?auto=format&fit=crop&q=80&w=200&h=200",
            "https://images.unsplash.com/photo-1591561954557-26941169b49e?auto=format&fit=crop&q=80&w=200&h=200"
        ]
    }
];

const CategoryGrid: React.FC = () => {
  const sliderSettings = {
    dots: false, infinite: true, speed: 600, slidesToShow: 5, slidesToScroll: 1, autoplay: true, autoplaySpeed: 3000, cssEase: "linear",
    responsive: [ { breakpoint: 1024, settings: { slidesToShow: 3 } }, { breakpoint: 640, settings: { slidesToShow: 2 } } ],
  };

  return (
    <div className="max-w-[1400px] mx-auto px-4 md:px-6 mb-8 mt-4">

      {/* --- SECTION 1: BLUE SLIDER --- */}
      <div className="relative p-6 md:p-8 rounded-xl text-white shadow-xl overflow-hidden mb-10" style={{ backgroundImage: "url('https://static.vecteezy.com/system/resources/thumbnails/004/299/815/small/online-shopping-on-phone-buy-sell-business-digital-web-banner-application-money-advertising-payment-ecommerce-illustration-search-vector.jpg')", backgroundSize: "cover", backgroundPosition: "center" }}>
        <div className="absolute inset-0 bg-blue-900/95"></div>
        <div className="relative z-10 flex flex-col md:flex-row justify-between items-center mb-6">
            <div className="mb-4 md:mb-0">
              <h2 className="text-xl md:text-3xl font-bold mb-2 text-white">October 2026 Global Sources</h2>
              <p className="text-sm text-gray-200">Hot products, new trends, more sourcing opportunities.</p>
            </div>
            <Link to="/all-categories" className="bg-orange-500 hover:bg-orange-600 transition duration-300 px-6 py-2 rounded-full font-bold shadow-lg">View More</Link>
        </div>

        <div className="relative z-10">
            <Slider {...sliderSettings}>
            {mainGridCategories.map((category) => (
                <div key={category.id} className="p-2 h-full">
                    {/* Pass Category Name & Image via State */}
                    <Link 
                        to={`/categories/${category.id}`} 
                        state={{ name: category.name, bannerImage: category.imagePlaceholder }}
                        className="block bg-white rounded-lg p-3 flex flex-col items-center text-center shadow-md hover:shadow-lg transition-transform hover:-translate-y-1 cursor-pointer h-full min-h-[140px] justify-between group"
                    >
                        <img src={category.imagePlaceholder} alt={category.name} className="h-20 w-full object-cover rounded mb-2 group-hover:scale-105 transition-transform duration-300" />
                        <span className="text-gray-800 text-xs font-bold leading-tight group-hover:text-blue-600 transition-colors">{category.name}</span>
                    </Link>
                </div>
            ))}
            </Slider>
        </div>
      </div>
      
      {/* --- SECTION 2: BOTTOM 3 GRIDS --- */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {bottomGridData.map((item, index) => (
              <div key={index} className={`bg-white rounded-xl shadow-sm border-t-4 ${item.borderColor} flex flex-col overflow-hidden hover:shadow-lg transition-all duration-300 group`}>
                  <div className="p-5 flex-1 flex flex-col">
                      <div className="flex justify-between items-start mb-3">
                          <div>
                              <h3 className="text-lg font-bold text-gray-900 group-hover:text-blue-700 transition-colors">{item.title}</h3>
                              <p className="text-xs text-gray-500 mt-1">{item.description}</p>
                          </div>
                          
                          {/* Main See All Link */}
                          <Link 
                            to={`/categories/${item.categoryId}`} 
                            state={{ name: item.title, bannerImage: item.images[0] }} 
                            className="text-blue-600 text-xs font-bold hover:underline whitespace-nowrap bg-blue-50 px-2 py-1 rounded-full"
                          >
                              See All
                          </Link>
                      </div>

                      {/* Clickable Images */}
                      <div className="flex gap-2 mt-auto h-24">
                          {item.images.map((imgUrl, imgIndex) => (
                              <Link 
                                key={imgIndex} 
                                to={`/categories/${item.categoryId}`}
                                state={{ name: item.title, bannerImage: imgUrl }} // Image clicked becomes banner
                                className="w-1/3 h-full border border-gray-100 rounded-lg p-1 flex items-center justify-center bg-gray-50 overflow-hidden hover:border-blue-300 transition-colors"
                              >
                                <img src={imgUrl} alt="Product" className="max-w-full max-h-full object-contain hover:scale-110 transition-transform duration-300 mix-blend-multiply" />
                              </Link>
                          ))}
                      </div>
                  </div>
              </div>
          ))}
      </div>
    </div>
  );
};

export default CategoryGrid;